export default class HeaderMobileMenu {
    constructor($el) {
        this.$el = $el;
        this.$toggle = this.$el.querySelector('[data-header-mobile-menu-toggle]');
        this.$panel = this.$el.querySelector('[data-header-mobile-menu-panel]');

        if ( ! this.$toggle || ! this.$panel) {
            return;
        }

        this.$links = this.$panel.querySelectorAll('a');

        this.toggle = this.toggle.bind(this);
        this.close = this.close.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleResize = this.handleResize.bind(this);

        this.$toggle.addEventListener('click', this.toggle);
        this.$links.forEach($link => $link.addEventListener('click', this.close));
        document.addEventListener('keydown', this.handleKeydown);
        window.addEventListener('resize', this.handleResize);
    }

    toggle() {
        this.setOpen( ! this.$el.classList.contains('menu-open'));
    }

    close() {
        this.setOpen(false);
    }

    setOpen(isOpen) {
        this.$el.classList.toggle('menu-open', isOpen);
        document.body.classList.toggle('mobile-menu-open', isOpen);
        this.$toggle.setAttribute('aria-expanded', isOpen.toString());
    }

    handleKeydown(event) {
        if (event.key === 'Escape' && this.$el.classList.contains('menu-open')) {
            this.close();
            this.$toggle.focus();
        }
    }

    handleResize() {
        if (window.innerWidth >= 992 && this.$el.classList.contains('menu-open')) {
            this.close();
        }
    }
}
